import {api} from './base';
import {handleApiError} from './util';
import {ApiResponse} from "../types/response";

export const getTermAPI = async (): Promise<string> => { //데이터 사업 규정 조회 API
    try {
        const response = await api.get<ApiResponse<string>>('/terms/term');
        if (!response.data.success) {
            throw new Error(response.data.data.message);
        }
        return response.data.data;
    } catch (error) {
        handleApiError(error, '오류가 발생했습니다.');
        throw error;
    }
}

export const getPolicyAPI = async (): Promise<string> => { //개인정보 처리 규정 조회 API
    try {
        const response = await api.get<ApiResponse<string>>('/terms/policy');
        if (!response.data.success) {
            throw new Error(response.data.data.message);
        }
        return response.data.data;
    } catch (error) {
        handleApiError(error, '오류가 발생했습니다.');
        throw error;
    }
}

export const getRegisterAPI = async (): Promise<string> => { //회원가입 규정 조회 API
    try {
        const response = await api.get<ApiResponse<string>>('/terms/register');
        if (!response.data.success) {
            throw new Error(response.data.data.message);
        }
        return response.data.data;
    } catch (error) {
        handleApiError(error, '오류가 발생했습니다.');
        throw error;
    }
}